/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpLeftIcon24Regular = forwardRef('ArrowDCornerUpLeftIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M9.131 1.631A.875.875 0 1 1 10.37 2.87L5.112 8.125H17A3.875 3.875 0 0 1 20.875 12v9a.875.875 0 1 1-1.75 0v-9A2.125 2.125 0 0 0 17 9.875H5.112l5.257 5.256A.875.875 0 1 1 9.13 16.37l-5.504-5.504a2.638 2.638 0 0 1 0-3.73l5.504-5.504Z" })));
});
